import React, { useState } from "react";
import { StyleSheet, View, TouchableOpacity } from "react-native";
import { Image } from "expo-image";
import { MD3Theme, useTheme } from "react-native-paper";
import InfoCardText from "./InfoCardText";
import { InfoCardTextProps } from "../types/types";
import { mobAlert } from "../mobx/MobAlert";
import { mobUser } from "../mobx/MobUser";
import HomePageButton from "./HomePageButton";
import { LocationIcon } from "./Icons";
import i18n from "../i18n";
import { openMapByLatLng } from "../utils/itinerary";
import { Text } from "../utils/fontsLoader";
import { SafeAreaView } from "react-native-safe-area-context";

interface InfoCardProps {
  fieldMap: InfoCardTextProps[]
}

export default function InfoCard({ fieldMap }: InfoCardProps) {
  const theme = useTheme();
  const styles = styleGen(theme);

  const iconSize = 50;

  return (
    <SafeAreaView style={{ flex: 1 }} edges={['bottom']}>
      <View style={styles.container}>
        {fieldMap?.map((field, idx) => (
          <View key={idx}>
            <InfoCardText title={field.context?.translatedTitle?.[mobUser.Language] || field.title} text={field.context?.description?.[mobUser.Language] || field.text} />
            {field.context?.address && !!field.context?.location && (
              <TouchableOpacity
                style={styles.addressContainer}
                onPress={() =>
                  openMapByLatLng(field.context.location.lat, field.context.location.lng)
                }
              >
                <LocationIcon height={iconSize} width={iconSize} style={styles.icon} />
                <Text style={styles.addressText}>{i18n.t("pages.parking.viewOnMap")}</Text>
              </TouchableOpacity>
            )}

            {field.container && field.name &&
              <TouchableOpacity style={styles.image} onPress={() => mobAlert.setImageModal(0, [{ url: field.container + "/" + field.name }])}>
                <Image style={styles.image} source={{ uri: field.container + "/" + field.name }} />
              </TouchableOpacity>
            }
          </View>
        ))}
      </View>
    </SafeAreaView>
  );
}

const styleGen = (theme: MD3Theme) => StyleSheet.create({
  container: {
    padding: 10,
    borderRadius: 20,
    gap: 20,
    borderColor: theme.colors.secondary,
    borderWidth: 3,
  },
  image: {
    alignSelf: "center",
    marginTop: 5,
    marginBottom: 15,
    borderRadius: 20,
    width: "90%",
    height: 200,
  },
  addressText: {
    fontSize: 18,
    textDecorationLine: "underline",
    color: "dodgerblue",
    flexWrap: 'wrap',
  },
  addressContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 5,
    alignSelf: 'flex-start',
    marginTop: 5,
    flexWrap: 'wrap',
  },
  buttonText: {
    fontSize: 16,
    color: theme.colors.onBackground,
  },
  icon: {
    marginRight: 10,
  },
});
